<template>
  <div class="disk-share">
    <div class="disk-share-brand">
      <img :src="folderIcon" alt="">
      <span>网盘分享</span>
    </div>
    <div :class="['disk-share-box', { wide: opened && share.nodeType !== 2 }]">
      <div v-if="loading" class="disk-share-state">
        <Spin size="large"></Spin>
        <p>正在打开分享…</p>
      </div>
      <div v-else-if="invalid" class="disk-share-state">
        <img :src="fileIcon" alt="" class="disk-share-state-icon dim">
        <p class="disk-share-state-title">{{ invalidMsg }}</p>
        <p>分享可能已过期或被撤销，请联系分享人重新分享</p>
      </div>
      <div v-else-if="needCode" class="disk-share-code">
        <img :src="folderIcon" alt="" class="disk-share-state-icon">
        <p class="disk-share-state-title">请输入提取码</p>
        <p class="disk-share-code-sub">分享人设置了提取码，输入后即可查看文件</p>
        <div class="disk-share-code-form">
          <Input v-model="extractCode" size="large" placeholder="提取码" :maxlength="8"
                 @on-enter="openShare"></Input>
          <Button type="primary" size="large" :loading="opening" @click="openShare">提取文件</Button>
        </div>
        <p v-if="codeError" class="disk-share-error">{{ codeError }}</p>
      </div>
      <div v-else-if="opened">
        <div class="disk-share-hero">
          <img :src="iconOf(share)" alt="" class="disk-share-hero-icon">
          <div class="disk-share-hero-main">
            <div class="disk-share-name" :title="share.name">{{ share.name }}</div>
            <div class="disk-share-meta">
              <span v-if="share.nodeType === 2">{{ formatSize(share.size) }}</span>
              <span v-else>{{ (share.children || []).length }} 项</span>
            </div>
          </div>
          <div v-if="share.nodeType === 2" class="disk-share-hero-ops">
            <Button size="large" icon="ios-eye-outline" @click="preview(share.id, share)">预览</Button>
            <Button type="primary" size="large" icon="ios-download-outline" @click="download(share.id)">下载</Button>
          </div>
        </div>
        <div v-if="share.nodeType !== 2" class="disk-share-list">
          <Table :columns="columns" :data="share.children || []" no-data-text="文件夹是空的"></Table>
        </div>
      </div>
    </div>
    <Modal v-model="showPreviewModal" class-name="disk-modal" :title="previewName" width="960" @on-visible-change="onPreviewVisible">
      <div class="disk-preview" :class="{ 'disk-preview-center': centerPreview }">
        <div v-if="previewLoading" class="disk-preview-tip">加载中...</div>
        <div v-else-if="previewError" class="disk-preview-tip">{{ previewError }}</div>
        <img v-else-if="previewType === 'image'" :src="previewUrl" class="disk-preview-image">
        <iframe v-else-if="previewType === 'pdf'" :src="previewBlobUrl" class="disk-preview-frame"></iframe>
        <template v-else-if="previewType === 'video'">
          <video ref="previewVideo" :src="previewUrl" controls class="disk-preview-media" @error="onMediaError"></video>
          <div v-if="mediaError" class="disk-preview-tip">该格式无法预览，请下载</div>
        </template>
        <template v-else-if="previewType === 'audio'">
          <audio ref="previewAudio" :src="previewUrl" controls @error="onMediaError"></audio>
          <div v-if="mediaError" class="disk-preview-tip">该格式无法预览，请下载</div>
        </template>
        <template v-else-if="previewType === 'office' && previewEngine === 'aliyun'">
          <div ref="aliyunOffice" class="disk-preview-frame"></div>
        </template>
        <template v-else-if="previewType === 'office'">
          <iframe :src="officeUrl" class="disk-preview-frame"></iframe>
          <div class="disk-preview-hint">若无法打开，请下载后查看</div>
        </template>
        <template v-else-if="previewType === 'csv'">
          <div v-if="previewEmpty" class="disk-preview-tip">没有可预览的内容</div>
          <div v-else class="disk-preview-table-wrap">
            <table class="disk-preview-table">
              <tbody>
                <tr v-for="(line, lineIndex) in previewRows" :key="lineIndex">
                  <td v-for="(cell, cellIndex) in line" :key="cellIndex"
                      :class="{ 'disk-preview-th': lineIndex === 0 }">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <div v-else-if="previewType === 'markdown'" class="disk-preview-markdown" v-html="previewHtml"></div>
        <template v-else-if="previewType === 'json'">
          <div v-if="jsonError" class="disk-preview-hint">不是合法 JSON</div>
          <pre class="disk-preview-pre">{{ previewText }}</pre>
        </template>
        <pre v-else-if="previewType === 'text'" class="disk-preview-pre">{{ previewText }}</pre>
        <div v-else class="disk-preview-tip">该格式无法预览，请下载</div>
      </div>
      <div slot="footer">
        <Button type="primary" icon="ios-download" @click="download(previewDownloadId)">下载</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
  import {iconFolder, iconFile, fileIconOf} from './fileIcon'

  export default {
    name: 'DiskShare',
    data () {
      return {
        token: '',
        extractCode: '',
        loading: true,
        opening: false,
        invalid: false,
        invalidMsg: '链接失效',
        needCode: false,
        codeError: '',
        opened: false,
        share: {},
        showPreviewModal: false,
        previewUrl: '',
        previewBlobUrl: '',
        previewEngine: '',
        previewWebofficeUrl: '',
        previewAccessToken: '',
        previewRefreshToken: '',
        previewType: '',
        previewName: '',
        previewExt: '',
        previewDownloadId: null,
        previewLoading: false,
        previewError: '',
        previewText: '',
        previewHtml: '',
        previewRows: [],
        previewEmpty: false,
        jsonError: false,
        mediaError: false,
        folderIcon: iconFolder,
        fileIcon: iconFile,
        columns: [
          {
            title: '名称',
            minWidth: 260,
            render: (h, params) => {
              let row = params.row
              let children = [
                h('img', {class: 'dss-icon', attrs: {src: this.iconOf(row), alt: ''}}),
                h('span', {class: 'dss-name', attrs: {title: row.name}}, row.name)
              ]
              if (row.nodeType === 2) {
                children.push(h('div', {class: 'dss-ops'}, [
                  h('span', {class: 'dss-op', on: {click: () => this.preview(row.id, row)}}, [h('Icon', {props: {type: 'ios-eye-outline', size: 18}}), h('span', '预览')]),
                  h('span', {class: 'dss-op', on: {click: () => this.download(row.id)}}, [h('Icon', {props: {type: 'ios-download-outline', size: 18}}), h('span', '下载')])
                ]))
              }
              return h('div', {class: 'dss-cell'}, children)
            }
          },
          {
            title: '大小',
            width: 120,
            align: 'right',
            render: (h, params) => h('span', {class: 'dss-muted'}, params.row.nodeType === 2 ? this.formatSize(params.row.size) : '-')
          }
        ]
      }
    },
    computed: {
      centerPreview () {
        return ['image', 'pdf', 'video', 'audio'].indexOf(this.previewType) >= 0
      },
      officeUrl () {
        return 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(this.previewUrl || '')
      }
    },
    created () {
      this.token = this.$route.query.token || ''
      this.extractCode = this.$route.query.extractCode || ''
      if (!this.token) {
        this.loading = false
        this.invalid = true
        return
      }
      this.loadMeta()
    },
    methods: {
      iconOf (node) {
        return fileIconOf(node && node.name, node && node.nodeType !== 2)
      },
      loadMeta () {
        let self = this
        self.loading = true
        self.$http.get('/disk/share/meta', {params: {token: self.token}}).then(function (res) {
          self.loading = false
          if (res.status !== 'ok' || !res.data) {
            self.invalid = true
            self.invalidMsg = res.msg || '链接失效'
            return
          }
          let meta = res.data
          if (meta.expired) {
            self.invalid = true
            self.invalidMsg = '链接失效'
            return
          }
          self.needCode = !!meta.needCode
          if (!self.needCode || self.extractCode) {
            self.openShare()
          }
        })
      },
      openShare () {
        let self = this
        if (self.needCode && !self.extractCode) {
          self.$Message.warning('请输入提取码')
          return
        }
        self.opening = true
        self.codeError = ''
        self.$http.post('/disk/share/open', {token: self.token, extractCode: self.extractCode}).then(function (res) {
          self.opening = false
          if (res.status !== 'ok' || !res.data) {
            let msg = res.msg || '链接失效'
            if (msg.indexOf('提取码') >= 0) {
              self.codeError = msg
            } else {
              self.invalid = true
              self.invalidMsg = msg
            }
            return
          }
          self.share = res.data
          self.needCode = false
          self.opened = true
        }).catch(function () {
          self.opening = false
        })
      },
      download (nodeId) {
        let self = this
        if (nodeId == null || nodeId === '') {
          nodeId = self.share.id || ''
        }
        self.$http.post('/disk/share/fileUrl', {
          token: self.token,
          extractCode: self.extractCode,
          nodeId: nodeId
        }).then(function (res) {
          if (res.status === 'ok' && res.data && res.data.url) {
            self.openUrl(res.data.url)
          } else if (res.msg) {
            self.$Message.error(res.msg)
          }
        })
      },
      preview (nodeId, row) {
        let self = this
        let file = row || self.share
        if (!file || file.nodeType !== 2) {
          return
        }
        if (!self.resolvePreviewType(file)) {
          self.$Message.warning('请下载后查看')
          return
        }
        let id = nodeId == null || nodeId === '' ? file.id : nodeId
        self.$http.post('/disk/share/fileUrl', {
          token: self.token,
          extractCode: self.extractCode,
          nodeId: id,
          inline: true
        }).then(function (res) {
          if (res && res.status === 'ok' && res.data && (res.data.url || res.data.engine === 'aliyun')) {
            self.resetPreview()
            self.previewUrl = res.data.url || ''
            self.previewType = self.resolvePreviewType(file)
            self.previewExt = self.resolveExt(file)
            self.previewName = file.name
            self.previewDownloadId = id
            if (self.previewType === 'office' && res.data.engine === 'aliyun') {
              self.openAliyunOffice(res.data)
            } else {
              self.previewEngine = 'oss'
              self.showPreviewModal = true
              if (self.previewType === 'pdf') {
                self.loadPreviewPdf()
              } else if (self.isTextPreview()) {
                self.loadPreviewText()
              }
            }
          } else if (res && res.msg) {
            self.$Message.error(res.msg)
          }
        })
      },
      resetPreview () {
        this.destroyAliyunOffice()
        this.revokePreviewBlob()
        this.previewUrl = ''
        this.previewType = ''
        this.previewExt = ''
        this.previewName = ''
        this.previewDownloadId = null
        this.previewLoading = false
        this.previewError = ''
        this.previewText = ''
        this.previewHtml = ''
        this.previewRows = []
        this.previewEmpty = false
        this.jsonError = false
        this.mediaError = false
      },
      resolveExt (row) {
        let ext = (row.ext || '').toLowerCase().replace(/^\./, '')
        if (ext) {
          return ext
        }
        let name = row.name || ''
        let index = name.lastIndexOf('.')
        if (index >= 0 && index < name.length - 1) {
          return name.substring(index + 1).toLowerCase()
        }
        return ''
      },
      resolvePreviewType (row) {
        let ext = this.resolveExt(row)
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico'].indexOf(ext) >= 0) {
          return 'image'
        }
        if (ext === 'pdf') {
          return 'pdf'
        }
        if (['mp4', 'webm', 'ogv', 'mov', 'm4v'].indexOf(ext) >= 0) {
          return 'video'
        }
        if (['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'].indexOf(ext) >= 0) {
          return 'audio'
        }
        if (['md', 'markdown'].indexOf(ext) >= 0) {
          return 'markdown'
        }
        if (ext === 'json') {
          return 'json'
        }
        if (['csv', 'tsv'].indexOf(ext) >= 0) {
          return 'csv'
        }
        if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].indexOf(ext) >= 0) {
          return 'office'
        }
        if (['txt', 'text', 'log', 'xml', 'html', 'htm', 'css', 'js', 'yml', 'yaml',
          'ini', 'properties', 'sql', 'conf', 'cfg'].indexOf(ext) >= 0) {
          return 'text'
        }
        return ''
      },
      stopPreviewMedia () {
        let players = [this.$refs.previewVideo, this.$refs.previewAudio]
        for (let i = 0; i < players.length; i++) {
          let player = players[i]
          if (!player) {
            continue
          }
          player.pause()
          player.removeAttribute('src')
          player.load()
        }
        this.previewUrl = ''
      },
      onPreviewVisible (visible) {
        if (!visible) {
          this.stopPreviewMedia()
          this.revokePreviewBlob()
          this.destroyAliyunOffice()
        }
      },
      openAliyunOffice (data) {
        let self = this
        self.previewEngine = 'aliyun'
        self.previewWebofficeUrl = data.webofficeUrl
        self.previewAccessToken = data.accessToken
        self.previewRefreshToken = data.refreshToken
        self.showPreviewModal = true
        self.loadAliyunSdk().then(function () {
          self.$nextTick(function () {
            if (!self.$refs.aliyunOffice) {
              self.$nextTick(function () {
                self.mountAliyunOffice()
              })
              return
            }
            self.mountAliyunOffice()
          })
        }).catch(function () {
          self.previewError = '阿里云预览组件加载失败'
        })
      },
      loadAliyunSdk () {
        if (window.aliyun && window.aliyun.config) {
          return Promise.resolve()
        }
        if (this._aliyunSdkPromise) {
          return this._aliyunSdkPromise
        }
        this._aliyunSdkPromise = new Promise(function (resolve, reject) {
          let script = document.createElement('script')
          script.src = 'https://g.alicdn.com/IMM/office-js/1.1.19/aliyun-web-office-sdk.min.js'
          script.onload = function () { resolve() }
          script.onerror = function () { reject() }
          document.head.appendChild(script)
        })
        return this._aliyunSdkPromise
      },
      mountAliyunOffice () {
        let self = this
        let mount = self.$refs.aliyunOffice
        if (!mount || !window.aliyun || !window.aliyun.config) {
          self.previewError = '阿里云预览组件加载失败'
          return
        }
        let ins = window.aliyun.config({
          mount: mount,
          url: self.previewWebofficeUrl,
          refreshToken: function () {
            return self.refreshAliyunOffice()
          }
        })
        ins.setToken({
          token: self.previewAccessToken,
          timeout: 25 * 60 * 1000
        })
        self._aliyunOffice = ins
      },
      refreshAliyunOffice () {
        let self = this
        return self.$http.post('/disk/share/previewRefresh', {
          token: self.token,
          extractCode: self.extractCode,
          nodeId: self.previewDownloadId,
          accessToken: self.previewAccessToken,
          refreshToken: self.previewRefreshToken
        }).then(function (res) {
          if (!res || res.status !== 'ok' || !res.data || !res.data.accessToken) {
            return Promise.reject()
          }
          self.previewAccessToken = res.data.accessToken
          if (res.data.refreshToken) {
            self.previewRefreshToken = res.data.refreshToken
          }
          return {
            token: res.data.accessToken,
            timeout: 25 * 60 * 1000
          }
        })
      },
      destroyAliyunOffice () {
        let ins = this._aliyunOffice
        this._aliyunOffice = null
        if (ins && ins.destroy) {
          try {
            ins.destroy()
          } catch (e) {}
        }
        this.previewEngine = ''
        this.previewWebofficeUrl = ''
        this.previewAccessToken = ''
        this.previewRefreshToken = ''
      },
      revokePreviewBlob () {
        if (this.previewBlobUrl) {
          URL.revokeObjectURL(this.previewBlobUrl)
          this.previewBlobUrl = ''
        }
      },
      loadPreviewPdf () {
        let self = this
        let maxSize = 40 * 1024 * 1024
        let tooLarge = false
        self.previewLoading = true
        self.previewError = ''
        self.revokePreviewBlob()
        let xhr = new XMLHttpRequest()
        xhr.open('GET', self.previewUrl, true)
        xhr.responseType = 'arraybuffer'
        xhr.onreadystatechange = function () {
          if (xhr.readyState !== 2) {
            return
          }
          let headerLength = Number(xhr.getResponseHeader('Content-Length'))
          if (!isNaN(headerLength) && headerLength > maxSize) {
            tooLarge = true
            xhr.abort()
          }
        }
        xhr.onload = function () {
          if (xhr.status < 200 || xhr.status >= 300) {
            self.previewLoading = false
            self.previewError = '预览加载失败，请下载'
            return
          }
          let blob = new Blob([xhr.response], {type: 'application/pdf'})
          self.previewBlobUrl = URL.createObjectURL(blob)
          self.previewLoading = false
        }
        xhr.onerror = function () {
          self.previewLoading = false
          self.previewError = '预览加载失败，请下载'
        }
        xhr.onabort = function () {
          if (tooLarge) {
            self.previewLoading = false
            self.previewError = '文件过大，请下载'
          }
        }
        xhr.send()
      },
      isTextPreview () {
        return ['markdown', 'json', 'csv', 'text'].indexOf(this.previewType) >= 0
      },
      onMediaError () {
        this.mediaError = true
      },
      loadPreviewText () {
        let self = this
        let maxSize = 2 * 1024 * 1024
        let tooLarge = false
        self.previewLoading = true
        self.previewError = ''
        self.previewText = ''
        self.previewHtml = ''
        self.previewRows = []
        self.previewEmpty = false
        self.jsonError = false
        let xhr = new XMLHttpRequest()
        xhr.open('GET', self.previewUrl, true)
        xhr.responseType = 'arraybuffer'
        xhr.onreadystatechange = function () {
          if (xhr.readyState !== 2) {
            return
          }
          let headerLength = Number(xhr.getResponseHeader('Content-Length'))
          if (!isNaN(headerLength) && headerLength > maxSize) {
            tooLarge = true
            xhr.abort()
          }
        }
        xhr.onload = function () {
          if (xhr.status < 200 || xhr.status >= 300) {
            self.previewLoading = false
            self.previewError = '预览加载失败，请下载'
            return
          }
          if (self.isSpreadsheetBytes(xhr.response)) {
            self.loadPreviewSheet()
            return
          }
          let text = self.decodePreviewBytes(xhr.response)
          let bodyLength = Number(xhr.getResponseHeader('Content-Length'))
          if (isNaN(bodyLength) || bodyLength <= 0) {
            bodyLength = self.byteLength(text)
          }
          if (bodyLength > maxSize) {
            self.previewLoading = false
            self.previewError = '文件过大，请下载'
            return
          }
          self.previewText = text
          self.renderPreviewText()
          self.previewLoading = false
        }
        xhr.onerror = function () {
          self.previewLoading = false
          self.previewError = '预览加载失败，请下载'
        }
        xhr.onabort = function () {
          if (tooLarge) {
            self.previewLoading = false
            self.previewError = '文件过大，请下载'
          }
        }
        xhr.send()
      },
      isSpreadsheetBytes (buffer) {
        let bytes = new Uint8Array(buffer || [])
        if (bytes.length >= 8 && bytes[0] === 208 && bytes[1] === 207 && bytes[2] === 17 && bytes[3] === 224) {
          return true
        }
        return bytes.length >= 4 && bytes[0] === 80 && bytes[1] === 75
      },
      loadPreviewSheet () {
        let self = this
        self.previewType = 'csv'
        self.$http.post('/disk/share/previewTable', {
          token: self.token,
          extractCode: self.extractCode,
          nodeId: self.previewDownloadId
        }).then(function (res) {
          self.previewLoading = false
          if (res && res.status === 'ok') {
            self.previewRows = res.data || []
            self.previewEmpty = !self.previewRows.length
            return
          }
          self.previewError = (res && res.msg) || '请下载后查看'
        }).catch(function () {
          self.previewLoading = false
          self.previewError = '预览加载失败，请下载'
        })
      },
      decodePreviewBytes (buffer) {
        let bytes = new Uint8Array(buffer || [])
        if (bytes.length >= 3 && bytes[0] === 239 && bytes[1] === 187 && bytes[2] === 191) {
          bytes = bytes.subarray(3)
        }
        if (!window.TextDecoder) {
          return ''
        }
        try {
          return new TextDecoder('utf-8', {fatal: true}).decode(bytes)
        } catch (e) {
          try {
            return new TextDecoder('gbk').decode(bytes)
          } catch (e2) {
            return new TextDecoder('utf-8').decode(bytes)
          }
        }
      },
      byteLength (text) {
        let value = String(text == null ? '' : text)
        if (window.Blob) {
          return new Blob([value]).size
        }
        return value.length
      },
      renderPreviewText () {
        if (this.previewType === 'markdown') {
          this.previewHtml = this.renderMarkdown(this.previewText)
          return
        }
        if (this.previewType === 'json') {
          try {
            this.previewText = JSON.stringify(JSON.parse(this.previewText), null, 2)
          } catch (e) {
            this.jsonError = true
          }
          return
        }
        if (this.previewType === 'csv') {
          this.previewRows = this.parseTable(this.previewText)
          this.previewEmpty = !this.previewRows.length
        }
      },
      parseTable (text) {
        let content = String(text == null ? '' : text).replace(/^\uFEFF/, '')
        if (!content.replace(/\s/g, '')) {
          return []
        }
        let lines = content.replace(/\r\n?/g, '\n').split('\n')
        while (lines.length && !lines[lines.length - 1].trim()) {
          lines.pop()
        }
        if (this.previewExt === 'tsv') {
          return lines.map(function (line) {
            return line.split('\t')
          })
        }
        return this.parseCsv(lines.join('\n'))
      },
      parseCsv (text) {
        let rows = []
        let row = []
        let field = ''
        let inQuotes = false
        let index = 0
        while (index < text.length) {
          let char = text.charAt(index)
          if (inQuotes) {
            if (char === '"') {
              if (text.charAt(index + 1) === '"') {
                field += '"'
                index += 2
              } else {
                inQuotes = false
                index++
              }
            } else {
              field += char
              index++
            }
            continue
          }
          if (char === '"' && field === '') {
            inQuotes = true
            index++
            continue
          }
          if (char === ',') {
            row.push(field)
            field = ''
            index++
            continue
          }
          if (char === '\n') {
            row.push(field)
            rows.push(row)
            row = []
            field = ''
            index++
            continue
          }
          field += char
          index++
        }
        if (field !== '' || row.length) {
          row.push(field)
          rows.push(row)
        }
        return rows
      },
      escapeHtml (text) {
        return String(text == null ? '' : text).
          replace(/&/g, '&amp;').
          replace(/</g, '&lt;').
          replace(/>/g, '&gt;').
          replace(/"/g, '&quot;').
          replace(/'/g, '&#39;')
      },
      safeUrl (url) {
        let value = String(url == null ? '' : url).trim()
        if (/^(https?:|mailto:|\/|\.\/|\.\.\/|#)/i.test(value)) {
          return value
        }
        return '#'
      },
      attrValue (text) {
        return String(text == null ? '' : text).
          replace(/&quot;|&#34;|&#x0*22;|&#39;|&#x0*27;|"|'/gi, '')
      },
      renderInline (text) {
        let self = this
        let segments = String(text == null ? '' : text).split('`')
        let html = ''
        for (let i = 0; i < segments.length; i++) {
          if (i % 2 === 1) {
            html += '<code>' + segments[i] + '</code>'
          } else {
            html += self.renderInlineFormat(segments[i])
          }
        }
        return html
      },
      renderInlineFormat (text) {
        let self = this
        let html = text
        html = html.replace(/!\[([^\]]*)\]\(([^)\s]+)\)/g, function (match, alt, src) {
          return '<img src="' + self.attrValue(self.safeUrl(src)) + '" alt="' + self.attrValue(alt) + '">'
        })
        html = html.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (match, label, href) {
          return '<a href="' + self.attrValue(self.safeUrl(href)) + '" target="_blank" rel="noopener">' + label + '</a>'
        })
        html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>')
        return html
      },
      renderMarkdown (text) {
        let self = this
        let lines = self.escapeHtml(text).replace(/\r\n?/g, '\n').split('\n')
        let html = []
        let paragraph = []
        let quoteLines = []
        let listType = ''
        let codeLines = []
        let inCode = false
        let index = 0
        let flushParagraph = function () {
          if (paragraph.length) {
            html.push('<p>' + self.renderInline(paragraph.join(' ')) + '</p>')
            paragraph = []
          }
        }
        let flushQuote = function () {
          if (quoteLines.length) {
            html.push('<blockquote>' + self.renderInline(quoteLines.join(' ')) + '</blockquote>')
            quoteLines = []
          }
        }
        let flushList = function () {
          if (listType) {
            html.push('</' + listType + '>')
            listType = ''
          }
        }
        while (index < lines.length) {
          let line = lines[index]
          if (/^\s*```/.test(line)) {
            if (inCode) {
              html.push('<pre><code>' + codeLines.join('\n') + '</code></pre>')
              codeLines = []
              inCode = false
            } else {
              flushParagraph()
              flushList()
              flushQuote()
              inCode = true
            }
            index++
            continue
          }
          if (inCode) {
            codeLines.push(line)
            index++
            continue
          }
          if (line.indexOf('|') >= 0 && index + 1 < lines.length && self.isTableSeparator(lines[index + 1])) {
            flushParagraph()
            flushList()
            flushQuote()
            let rows = [line]
            index += 2
            while (index < lines.length && lines[index].indexOf('|') >= 0 && lines[index].trim()) {
              rows.push(lines[index])
              index++
            }
            html.push(self.renderTable(rows))
            continue
          }
          if (!line.trim()) {
            flushParagraph()
            flushList()
            flushQuote()
            index++
            continue
          }
          let heading = /^(#{1,6})\s+(.*)$/.exec(line)
          if (heading) {
            flushParagraph()
            flushList()
            flushQuote()
            html.push('<h' + heading[1].length + '>' + self.renderInline(heading[2].trim()) +
              '</h' + heading[1].length + '>')
            index++
            continue
          }
          if (/^\s*(-{3,}|\*{3,}|_{3,})\s*$/.test(line)) {
            flushParagraph()
            flushList()
            flushQuote()
            html.push('<hr>')
            index++
            continue
          }
          let quote = /^\s*&gt;\s?(.*)$/.exec(line)
          if (quote) {
            flushParagraph()
            flushList()
            quoteLines.push(quote[1])
            index++
            continue
          }
          flushQuote()
          let unordered = /^\s*[-*+]\s+(.*)$/.exec(line)
          if (unordered) {
            flushParagraph()
            if (listType !== 'ul') {
              flushList()
              html.push('<ul>')
              listType = 'ul'
            }
            html.push('<li>' + self.renderInline(unordered[1]) + '</li>')
            index++
            continue
          }
          let ordered = /^\s*\d+\.\s+(.*)$/.exec(line)
          if (ordered) {
            flushParagraph()
            if (listType !== 'ol') {
              flushList()
              html.push('<ol>')
              listType = 'ol'
            }
            html.push('<li>' + self.renderInline(ordered[1]) + '</li>')
            index++
            continue
          }
          flushList()
          paragraph.push(line.trim())
          index++
        }
        if (inCode) {
          html.push('<pre><code>' + codeLines.join('\n') + '</code></pre>')
        }
        flushParagraph()
        flushList()
        flushQuote()
        return html.join('\n')
      },
      isTableSeparator (line) {
        if (!line || line.indexOf('-') < 0) {
          return false
        }
        let cells = this.splitTableRow(line)
        if (!cells.length) {
          return false
        }
        for (let i = 0; i < cells.length; i++) {
          if (!/^:?-{2,}:?$/.test(cells[i].replace(/\s/g, ''))) {
            return false
          }
        }
        return true
      },
      splitTableRow (line) {
        let text = String(line == null ? '' : line).trim()
        if (text.charAt(0) === '|') {
          text = text.substring(1)
        }
        if (text.charAt(text.length - 1) === '|') {
          text = text.substring(0, text.length - 1)
        }
        return text.split('|').map(function (cell) {
          return cell.trim()
        })
      },
      renderTable (rows) {
        let self = this
        let head = self.splitTableRow(rows[0])
        let html = ['<table>', '<thead><tr>']
        head.forEach(function (cell) {
          html.push('<th>' + self.renderInline(cell) + '</th>')
        })
        html.push('</tr></thead><tbody>')
        for (let i = 1; i < rows.length; i++) {
          let cells = self.splitTableRow(rows[i])
          html.push('<tr>')
          for (let c = 0; c < head.length; c++) {
            html.push('<td>' + self.renderInline(cells[c] || '') + '</td>')
          }
          html.push('</tr>')
        }
        html.push('</tbody></table>')
        return html.join('')
      },
      openUrl (url) {
        let link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      formatSize (size) {
        if (size == null || size === '') {
          return '-'
        }
        let n = Number(size)
        if (isNaN(n) || n <= 0) {
          return '0 B'
        }
        let units = ['B', 'KB', 'MB', 'GB', 'TB']
        let i = 0
        while (n >= 1024 && i < units.length - 1) {
          n = n / 1024
          i++
        }
        return (i === 0 ? n : n.toFixed(2)) + ' ' + units[i]
      }
    }
  }
</script>
<style scoped>
  .disk-share {
    min-height: 100vh;
    padding: 0 16px 60px;
    background: linear-gradient(180deg, #eaf2ff 0%, #f5f7fa 320px);
  }

  .disk-share-brand {
    display: flex;
    align-items: center;
    max-width: 880px;
    margin: 0 auto;
    padding: 24px 0;
    font-size: 18px;
    font-weight: 600;
    color: #17233d;
  }

  .disk-share-brand img {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }

  .disk-share-box {
    width: 560px;
    max-width: 100%;
    margin: 40px auto 0;
    padding: 32px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 12px 40px rgba(23, 35, 61, 0.08);
  }

  .disk-share-box.wide {
    width: 880px;
    margin-top: 0;
  }

  .disk-share-state,
  .disk-share-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 0;
    color: #808695;
    text-align: center;
  }

  .disk-share-state p {
    margin-top: 8px;
  }

  .disk-share-state-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 8px;
  }

  .disk-share-state-icon.dim {
    opacity: 0.5;
  }

  .disk-share-state-title {
    color: #17233d;
    font-size: 18px;
    font-weight: 600;
  }

  .disk-share-code-sub {
    margin: 6px 0 20px;
  }

  .disk-share-code-form {
    display: flex;
    width: 360px;
    max-width: 100%;
  }

  .disk-share-code-form .ivu-btn {
    margin-left: 10px;
    border-radius: 8px;
  }

  .disk-share-code-form /deep/ .ivu-input {
    border-radius: 8px;
    letter-spacing: 2px;
  }

  .disk-share-error {
    margin-top: 10px;
    color: #ed4014;
  }

  .disk-share-hero {
    display: flex;
    align-items: center;
  }

  .disk-share-hero-icon {
    width: 64px;
    height: 64px;
    flex: 0 0 64px;
  }

  .disk-share-hero-main {
    flex: 1;
    min-width: 0;
    margin-left: 16px;
  }

  .disk-share-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #17233d;
    font-size: 18px;
    font-weight: 600;
  }

  .disk-share-meta {
    margin-top: 4px;
    color: #a8adb7;
    font-size: 13px;
  }

  .disk-share-hero-ops {
    display: flex;
    flex: 0 0 auto;
    margin-left: 16px;
  }

  .disk-share-hero-ops .ivu-btn {
    margin-left: 10px;
    border-radius: 8px;
  }

  .disk-share-list {
    margin-top: 24px;
  }

  .disk-share-list /deep/ .ivu-table-wrapper {
    border: none;
  }

  .disk-share-list /deep/ .ivu-table:before,
  .disk-share-list /deep/ .ivu-table:after {
    display: none;
  }

  .disk-share-list /deep/ .ivu-table-header th {
    background: #fafbfc;
    color: #808695;
    font-weight: normal;
  }

  .disk-share-list /deep/ .ivu-table-body td {
    height: 56px;
    border-bottom-color: #f2f3f5;
  }

  .disk-share-list /deep/ .ivu-table-row:hover td {
    background: #f3f8ff;
  }

  .disk-share-list /deep/ .dss-cell {
    position: relative;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .disk-share-list /deep/ .dss-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    margin-right: 12px;
  }

  .disk-share-list /deep/ .dss-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #17233d;
    font-size: 14px;
  }

  .disk-share-list /deep/ .dss-ops {
    position: absolute;
    top: 50%;
    right: 0;
    display: flex;
    padding: 2px 4px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(23, 35, 61, 0.08);
    transform: translateY(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s;
  }

  .disk-share-list /deep/ .ivu-table-row:hover .dss-ops {
    visibility: visible;
    opacity: 1;
  }

  .disk-share-list /deep/ .dss-op {
    display: inline-flex;
    align-items: center;
    height: 28px;
    padding: 0 10px;
    border-radius: 4px;
    color: #2d8cf0;
    cursor: pointer;
    white-space: nowrap;
  }

  .disk-share-list /deep/ .dss-op span {
    margin-left: 4px;
    font-size: 13px;
  }

  .disk-share-list /deep/ .dss-op:hover {
    background: #e8f2ff;
  }

  .disk-share-list /deep/ .dss-muted {
    color: #808695;
  }

  .disk-preview {
    min-height: 60px;
    text-align: left;
  }

  .disk-preview-center {
    text-align: center;
  }

  .disk-preview-image {
    max-width: 100%;
  }

  .disk-preview-media {
    max-width: 100%;
  }

  .disk-preview-frame {
    width: 100%;
    height: 640px;
    border: 0;
  }

  .disk-preview-tip {
    padding: 24px 0;
    color: #999;
  }

  .disk-preview-hint {
    margin-top: 8px;
    color: #999;
    font-size: 12px;
  }

  .disk-preview-pre {
    max-height: 560px;
    margin: 0;
    padding: 12px;
    overflow: auto;
    background: #f8f8f8;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    font-family: Consolas, Monaco, monospace;
    font-size: 13px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .disk-preview-table-wrap {
    max-height: 560px;
    overflow: auto;
  }

  .disk-preview-table {
    width: max-content;
    min-width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .disk-preview-table td {
    padding: 6px 10px;
    border: 1px solid #e8e8e8;
    text-align: left;
    white-space: nowrap;
  }

  .disk-preview-th {
    background: #f8f8f8;
    font-weight: bold;
  }

  .disk-preview-markdown {
    max-height: 560px;
    overflow: auto;
    text-align: left;
    line-height: 1.7;
  }

  .disk-preview-markdown >>> h1,
  .disk-preview-markdown >>> h2,
  .disk-preview-markdown >>> h3,
  .disk-preview-markdown >>> h4,
  .disk-preview-markdown >>> h5,
  .disk-preview-markdown >>> h6 {
    margin: 14px 0 8px;
    font-weight: bold;
  }

  .disk-preview-markdown >>> h1 {
    font-size: 24px;
  }

  .disk-preview-markdown >>> h2 {
    font-size: 20px;
  }

  .disk-preview-markdown >>> h3 {
    font-size: 17px;
  }

  .disk-preview-markdown >>> p {
    margin: 8px 0;
  }

  .disk-preview-markdown >>> ul,
  .disk-preview-markdown >>> ol {
    margin: 8px 0;
    padding-left: 24px;
  }

  .disk-preview-markdown >>> li {
    margin: 4px 0;
  }

  .disk-preview-markdown >>> blockquote {
    margin: 8px 0;
    padding: 4px 12px;
    color: #666;
    border-left: 3px solid #dcdee2;
  }

  .disk-preview-markdown >>> code {
    padding: 1px 5px;
    background: #f1f1f1;
    border-radius: 3px;
    font-family: Consolas, Monaco, monospace;
  }

  .disk-preview-markdown >>> pre {
    margin: 8px 0;
    padding: 12px;
    overflow: auto;
    background: #f8f8f8;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
  }

  .disk-preview-markdown >>> pre code {
    padding: 0;
    background: none;
  }

  .disk-preview-markdown >>> table {
    width: 100%;
    margin: 8px 0;
    border-collapse: collapse;
    font-size: 13px;
  }

  .disk-preview-markdown >>> th,
  .disk-preview-markdown >>> td {
    padding: 6px 10px;
    border: 1px solid #e8e8e8;
    text-align: left;
  }

  .disk-preview-markdown >>> img {
    max-width: 100%;
  }

  .disk-preview-markdown >>> hr {
    margin: 12px 0;
    border: 0;
    border-top: 1px solid #e8e8e8;
  }
</style>



// WEBPACK FOOTER //
// DiskShare.vue?8e15b944